import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

const withAccountHeader =
  (account: string) =>
  (axios: AxiosInstance): AxiosInstance => {
    axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
      if (!account) return config;
      else {
        config.headers['LifeOmic-Account'] = account;
        return config;
      }
    });
    return axios;
  };

export default withAccountHeader;
